import { render } from "./Form.vue?vue&type=template&id=72096dff&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=72096dff&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-72096dff"

export default script